import { useEffect, useState } from "react";
import { getAppConfig } from "../api/client";

/** Cached app catalog — banks, tiers, fees, templates, FAQs. */
export function useAppConfig() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await getAppConfig();
        if (!cancelled) setConfig(data);
      } catch (err) {
        if (!cancelled) setError(err.message || "Failed to load config");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { config, loading, error };
}

/** NIP bank code for verify/withdraw API calls. */
export function bankApiCode(bank) {
  if (!bank) return "";
  return bank.code || bank.bankCode || bank.id || "";
}
